import {
  REMOVE_ANSWER,
  REMOVE_ANSWER_SUCCESS,
  REMOVE_ANSWER_CLEAN,
  REMOVE_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  answer: undefined,
}

const AnswerRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_ANSWER:
      state = {
        ...state,
        loading: true,
        done: false,
        error: "",
      }
      break
    case REMOVE_ANSWER_SUCCESS:
      state = {
        ...state,
        answer: action.payload.answer,
        loading: false,
        done: true,
      }
      break
    case REMOVE_ANSWER_CLEAN:
      state = initialState
      break
    case REMOVE_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default AnswerRemove
